<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">عنوان موقع النشاط</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "sectorlocationForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> اسم موقع النشاط</label>
                                <input class="form-control" id="validation01" type="text" formControlName="title"
                                [tooltip]="fc.title.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.title.valid && (fc.title.touched)"
                                [class.is-invalid]="fc.title.invalid && (fc.title.touched)"
                                
                                     required
                                     placeholder="اسم موقع النشاط"
                                    containerClass="" />
                            </div>
                            <div class="col-6 mb-3">
                                <label for="validationCustom05"><span class="validation-required">*</span> نوع النشاط </label>
                                <ng-select #Governorate  [selectOnTab]="true" formControlName="sectorTypeId"
                                    class="form-control p-0" placeholder="اختر نوع النشاط"
                                    containerClass="" 
                                    id="validationCustom05">
                                    <ng-option *ngFor="let item of sectortype" [value]="item.id">{{item.title}}</ng-option>
                                </ng-select>
                            </div>
                                                           <!-- select keyword -->
                     <div class="col-lg-6 col-sm-12  mb-3" style="margin-top: 7px;">
                        <label for="validationCustom06"> كلمات دليلية</label>
                        <ng-multiselect-dropdown
                               formControlName="keyword"
                               [placeholder]="'اختر كلمة'"
                               [settings]="dropdownSettings"
                               [data]="keyword"
                               [(ngModel)]="selectedItems"
                               (onDeSelect)="onItemDeSelect($event)"
                               (onSelect)="onItemSelect($event)"
                               (onDeSelectAll)="onUnSelectAll($event)"
                               (onSelectAll)="onSelectAll($event)">
                                         </ng-multiselect-dropdown>
                    </div>
                        </div>
                        
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

